
import _ from "lodash";
const AdminFeeDetails = (serviceFeeList) => {
    
    const adminFee = serviceFeeList
        .filter((fee) => fee.fee_type === "Admin");
    return _.find(adminFee)
         
}
export default AdminFeeDetails